<template>
  <el-menu class="navbar" mode="horizontal" :default-active="$route.path">
    <hamburger v-if="navType === 'side'" class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb v-if="navType === 'side'"></breadcrumb>
    
    <!-- 顶部导航菜单 -->
    <template v-if="navType === 'top'">
      <!-- 普通菜单项 -->
      <el-menu-item 
        v-for="item in processedTopMenu.filter(item => item.type === 'menu-item')" 
        :key="'menu-' + item.id"
        :index="getMenuIndex(item)"
        @click="handleMenuItemClick(item)"
      >
        {{ item.route.meta.title || item.route.name }}
      </el-menu-item>
      
      <!-- 下拉菜单 -->
      <el-submenu 
        v-for="item in processedTopMenu.filter(item => item.type === 'submenu')" 
        :key="'submenu-' + item.id"
        :index="item.route.path"
      >
        <template slot="title">
          <span>{{ item.route.meta.title }}</span>
        </template>
        <el-menu-item 
          v-for="child in item.children" 
          :key="child.path"
          :index="child.fullPath || child.path"
          @click="handleMenuClick(child)"
        >
          {{ child.meta.title || child.name }}
        </el-menu-item>
      </el-submenu>
    </template>
    
    <!-- 通知下拉框 -->
    <el-dropdown class="notice-container" trigger="click" @visible-change="onNoticeVisibleChange">
      <div class="notice-wrapper">
        <i class="el-icon-bell notice-icon"></i>
        <span v-if="unreadCount > 0" class="notice-badge">{{ unreadCount }}</span>
      </div>
      <el-dropdown-menu slot="dropdown" class="notice-dropdown">
        <notice @updateUnreadCount="updateUnreadCount"></notice>
      </el-dropdown-menu>
    </el-dropdown>
    
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <img class="user-avatar" :src="avatar ? avatar : renderIcon" :title="name">
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/dashboard">
          <el-dropdown-item>
            首页
          </el-dropdown-item>
        </router-link>
        <router-link class="inlineBlock" to="/profile">
          <el-dropdown-item>
            个人信息
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Notice from '@/components/Notice'
import icon1 from '@/assets/images/png/icon-test_1.png'
import icon2 from '@/assets/images/png/icon-test_2.png'
import icon3 from '@/assets/images/png/icon-test_3.png'
import icon4 from '@/assets/images/png/icon-test_4.png'
import icon5 from '@/assets/images/png/icon-test_5.png'
import icon6 from '@/assets/images/png/icon-test_6.png'
import icon7 from '@/assets/images/png/icon-test_7.png'
import icon8 from '@/assets/images/png/icon-test_8.png'
import Hamburger from '@/components/Hamburger';
import { countUnread } from '@/api/notice';


export default {
  data() {
      return {
        currentIcon: '',
        unreadCount: 0,
        icon1,
        icon2,
        icon3,
        icon4,
        icon5,
        icon6,
        icon7,
        icon8
      }
  },
  components: {
    Breadcrumb,
    Hamburger,
    Notice
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'name',
      'routers'
    ]),
    navType() {
      return this.$store.state.app.navType;
    },
    renderIcon: function() {
      let randomList = [icon1, icon2, icon3, icon4, icon5, icon6, icon7, icon8];
      const randomNumber = Math.floor(Math.random() * 8);
      return randomList[randomNumber];
    },
    topMenuRoutes() {
      // 过滤出可见的顶级路由，且确保只返回用户有权限的路由
      return this.routers.filter(route => {
        // 过滤掉隐藏的路由和没有标题的路由
        if (route.hidden || !route.meta || !route.meta.title) {
          return false;
        }
        
        // 确保子路由有完整的路径
        if (route.children && route.children.length > 0) {
          // 为每个子路由设置完整路径
          route.children = route.children.map(child => {
            // 为子路由创建副本，避免修改原始路由对象
            const childCopy = {...child};
            // 确保子路由有完整的路径
            if (child.path && child.path.charAt(0) !== '/') {
              childCopy.fullPath = `${route.path}/${child.path}`;
            } else {
              childCopy.fullPath = child.path;
            }
            return childCopy;
          });
          
          const visibleChildren = route.children.filter(child => {
            return !child.hidden;
          });
          return visibleChildren.length > 0;
        }
        
        // 没有子路由的菜单直接返回true
        return true;
      });
    },
    // 预处理后的菜单数据，用于顶部导航
    processedTopMenu() {
      const menu = [];
      let id = 0;
      const pathSet = new Set();
      
      this.topMenuRoutes.forEach(route => {
        // 检查当前路由path是否已经处理过
        if (pathSet.has(route.path)) {
          return;
        }
        
        // 标记当前路由path为已处理
        pathSet.add(route.path);
        
        if (!route.children || route.children.length === 0) {
          // 没有子路由，直接添加到菜单
          menu.push({
            id: id++,
            type: 'menu-item',
            route: route
          });
        } else {
          // 过滤出可见的子路由
          const visibleChildren = route.children.filter(child => !child.hidden);
          
          // 对于有子路由的情况，总是显示父路由的模块名称
          menu.push({
            id: id++,
            type: visibleChildren.length > 1 ? 'submenu' : 'menu-item',
            route: route,
            children: visibleChildren
          });
          
          // 标记子路由path为已处理
          visibleChildren.forEach(child => {
            pathSet.add(child.path || child.fullPath);
          });
        }
      });
      
      return menu;
    }
  },
  created() {
    // countUnread().then(response => {
    //   if(response.data) {
    //     this.unreadCount = response.data;
    //   }
    // })
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    onNoticeVisibleChange(visible) {
      // 下拉框显示/隐藏时的回调
    },
    updateUnreadCount(value) {
      this.unreadCount = value
    },
    getMenuIndex(item) {
      // 当菜单项有子路由且只有一个子路由时，返回子路由的路径作为index
      if (item.children && item.children.length === 1) {
        const child = item.children[0];
        return child.fullPath || child.path;
      }
      // 否则返回当前路由的路径
      return item.route.fullPath || item.route.path;
    },
    handleMenuItemClick(item) {
      // 当菜单项有子路由且只有一个子路由时，跳转到子路由
      if (item.children && item.children.length === 1) {
        this.handleMenuClick(item.children[0]);
      } else {
        // 否则跳转到当前路由
        this.handleMenuClick(item.route);
      }
    },
    handleMenuClick(route) {
      // 确保路由对象有效
      if (route) {
        // 使用完整的路由路径进行跳转
        let fullPath = route.fullPath || route.path;
        
        // 对于相对路径，确保路径以/开头
        if (fullPath && fullPath.charAt(0) !== '/') {
          fullPath = '/' + fullPath;
        }
        
        // 检查目标路径是否与当前路径相同，避免重复跳转
        if (fullPath !== this.$route.path) {
          // 使用$router.push进行路由跳转
          this.$router.push(fullPath).catch(err => {
            // 捕获可能的路由跳转错误
            console.error('路由跳转失败:', err)
          })
        }
      } else {
        console.error('无效的路由对象:', route)
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .notice-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 100px;
    line-height: 50px;
    .notice-wrapper {
      cursor: pointer;
      position: relative;
      display: flex;
      align-items: center;
      height: 50px;
      .notice-icon {
        font-size: 18px;
        color: #606266;
      }
      .notice-badge {
        position: absolute;
        top: 8px;
        right: -8px;
        background: #f56c6c;
        color: white;
        border-radius: 50%;
        width: 16px;
        height: 16px;
        font-size: 10px;
        text-align: center;
        line-height: 16px;
      }
    }
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>

<style>
.notice-dropdown {
  padding: 0 !important;
}
.notice-dropdown .el-dropdown-menu {
  padding: 0 !important;
  margin: 0 !important;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue